import { attr } from '@ember-data/model';
import EmberDataBaseFragment from '@square/dashboard-data/models/ember-data-base-fragment';
export default EmberDataBaseFragment.extend({
  startTime: attr('date-time'),
  endTime: attr('date-time'),
  location: attr('string'),
  venue: attr('string')
});